import React, { useState } from 'react';
import SwiperCore, { Controller, Navigation, Pagination, Scrollbar, A11y, Thumbs } from 'swiper';
import type { SwiperOptions } from 'swiper';
import { SwiperSlide } from 'swiper/react';
import { Bullet, Close, Container, Content, ImageSelect, Swiper } from './styles';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/thumbs/thumbs.min.css';
SwiperCore.use([Controller, Navigation, Pagination, Scrollbar, Thumbs, A11y]);
export type SwiperProps = SwiperOptions & {
  slidesPreview?: number | 'auto';
  titleGallery?: string;
  dataGallery?: string[];
  onClose?: () => void;
  initialSlide?: number;
  onReachEnd?: () => void;
};
const SwiperReact: React.FC<SwiperProps> = ({
  initialSlide,
  dataGallery,
  titleGallery,
  onClose,
  onReachEnd
}) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  return <Content>
      <h1>{titleGallery}</h1>
      <Container>
        <Close onClick={onClose} />
        <Swiper
      // loop
      navigation slidesPerView={1} centeredSlides thumbs={{
        swiper: thumbsSwiper
      }} watchSlidesVisibility initialSlide={initialSlide} key={initialSlide} onReachEnd={onReachEnd}>
          {dataGallery?.map((image, idx) => <SwiperSlide key={idx}>
              <ImageSelect>
                <img src={image} alt="image" />
              </ImageSelect>
            </SwiperSlide>)}
        </Swiper>
      </Container>

      <Bullet>
        <Swiper initialSlide={initialSlide} onSwiper={setThumbsSwiper} freeMode spaceBetween={10} watchSlidesProgress slidesPerView="auto">
          {dataGallery?.map((bullet, idx) => <SwiperSlide key={idx}>
              <img src={bullet} alt="image" />
            </SwiperSlide>)}
        </Swiper>
      </Bullet>
    </Content>;
};
export default SwiperReact;